import React from 'react';

/**
 * Animated wavy divider/separator between sections
 * Creates a playful, flowing transition
 */
export default function WavyDivider({
    color = '#F7F4EE',
    height = 80,
    flip = false,
    animate = true,
    className = ''
}) {
    return (
        <div
            className={`relative w-full overflow-hidden ${className}`}
            style={{
                height: `${height}px`,
                marginTop: flip ? 0 : `-${height / 2}px`,
                marginBottom: flip ? `-${height / 2}px` : 0,
                transform: flip ? 'rotate(180deg)' : 'none'
            }}
            aria-hidden="true"
        >
            <svg
                viewBox="0 0 1440 120"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute bottom-0 w-full"
                style={{ height: '100%' }}
                preserveAspectRatio="none"
            >
                <path
                    d="M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 L1440,120 L0,120 Z"
                    fill={color}
                    className={animate ? 'animate-wave' : ''}
                />
                <path
                    d="M0,80 C240,140 480,20 720,80 C960,140 1200,20 1440,80 L1440,120 L0,120 Z"
                    fill={color}
                    opacity="0.5"
                    className={animate ? 'animate-wave-slow' : ''}
                />
            </svg>

            <style>{`
        @keyframes wave {
          0%, 100% {
            d: path("M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 L1440,120 L0,120 Z");
          }
          50% {
            d: path("M0,80 C240,20 480,100 720,40 C960,0 1200,100 1440,80 L1440,120 L0,120 Z");
          }
        }
        
        @keyframes wave-slow {
          0%, 100% {
            d: path("M0,80 C240,140 480,20 720,80 C960,140 1200,20 1440,80 L1440,120 L0,120 Z");
          }
          50% {
            d: path("M0,60 C240,0 480,120 720,60 C960,20 1200,120 1440,60 L1440,120 L0,120 Z");
          }
        }
        
        .animate-wave {
          animation: wave 8s ease-in-out infinite;
        }
        
        .animate-wave-slow {
          animation: wave-slow 12s ease-in-out infinite;
        }
      `}</style>
        </div>
    );
}
